import { FlowValidation } from './Rules/FlowValidation/FlowValidation';
import { FlowValidationConfig } from './Rules/FlowValidation/FlowValidationConfg';
import { NoMoreThenXHours } from './Rules/NoMoreThenXHours/NoMoreThenXHours';
// import { NoMoreThanXHoursPerDay } from './Rules/NoMoreThanXHoursPerDay';
import { NoMoreThenXHoursConfig } from './Rules/NoMoreThenXHours/NoMoreThenXHoursConfig';
import { OnlyAllowWithinEmployment } from './Rules/OnlyAllowWithinEmployment';
import { TimeEntriesMustHaveWorkType } from './Rules/TimeEntriesMustHaveWorkType';
import { NoCellErrors } from './Rules/NoCellErrors';
import { MinPercentPerDay } from './Rules/MinPercentPerDay/MinPercentPerDay';
import { MinPercentPerDayConfig } from './Rules/MinPercentPerDay/MinPercentPerDayConfig';
import { MaxPercentOfCapacityConfig } from './Rules/MaxPercentOfCapacity/MaxPercentOfCapacityConfig';
import { MaxPercentOfCapacity } from './Rules/MaxPercentOfCapacity/MaxPercentOfCapacity';
import { TimeSheetValidation } from '../api/generated/data-contracts';

//Validation Rules

// export enum validationRules {
//     noCellErrors = 'noCellErrors',
//     maxHoursAllowedPerPeriod = 'maxHoursAllowedPerPeriod',
//     maxHoursAllowedPerDay = 'maxHoursAllowedPerDay',
//     OnlyAllowWithinEmployment = 'OnlyAllowWithinEmployment',
//     TimeEntriesMustHaveWorkType = 'TimeEntriesMustHaveWorkType',
//     useFlowValidation = 'useFlowValidation',
//     minPercentPerDayEnabled = 'minPercentPerDayEnabled',
//     maxPercentOfCapacityEnabled = 'maxPercentOfCapacityEnabled',
//     // EmptyTimeSheetNotAllowed = 'EmptyTimeSheetNotAllowed',

// }

type Vkeys = keyof Omit<TimeSheetValidation, 'maxHoursPerDayEnabled' | 'maxHoursAllowedPerDay' | 'hourLimitEnabled'>;

export const validationRules: Record<Vkeys, Vkeys> = {
    emptyTimeSheetAllowed: 'emptyTimeSheetAllowed',
    flowUrl: 'flowUrl',
    // hourLimitEnabled: 'hourLimitEnabled',
    // maxHoursPerDayEnabled: 'maxHoursPerDayEnabled',
    // maxHoursAllowedPerDay: 'maxHoursAllowedPerDay',
    maxHoursPerPeriodEnabled: 'maxHoursPerPeriodEnabled',
    maxHoursAllowedPerPeriod: 'maxHoursAllowedPerPeriod',
    maxPercentOfCapacity: 'maxPercentOfCapacity',
    maxPercentOfCapacityEnabled: 'maxPercentOfCapacityEnabled',
    minPercentPerDay: 'minPercentPerDay',
    minPercentPerDayEnabled: 'minPercentPerDayEnabled',
    noCellErrors: 'noCellErrors',
    onlyAllowWithinEmployment: 'onlyAllowWithinEmployment',
    periodHourLimit: 'periodHourLimit',
    timeEntriesMustHaveWorkType: 'timeEntriesMustHaveWorkType',
    // timeLowerLimitConfig: 'timeLowerLimitConfig',
    useFlowValidation: 'useFlowValidation',
    // workDayBoundaries: 'workDayBoundaries',
};

//Validation function parameters (needed to fetch config from db)
export const validationRulesParameters = {
    [validationRules.noCellErrors]: [],
    [validationRules.maxHoursPerPeriodEnabled]: [validationRules.maxHoursAllowedPerPeriod],
    // [validationRules.hourLimitEnabled]: [validationRules.maxHoursAllowedPerPeriod],
    // [validationRules.maxHoursPerDayEnabled]: [validationRules.maxHoursAllowedPerDay],
    [validationRules.onlyAllowWithinEmployment]: [],
    [validationRules.timeEntriesMustHaveWorkType]: [],
    // [validationRules.EmptyTimeSheetNotAllowed]: [],
    [validationRules.useFlowValidation]: [validationRules.flowUrl],
    [validationRules.minPercentPerDayEnabled]: [validationRules.minPercentPerDay],
    [validationRules.maxPercentOfCapacityEnabled]: [validationRules.maxPercentOfCapacity],
};

//Validation functions
export const validationRulesFunction = {
    [validationRules.timeEntriesMustHaveWorkType]: TimeEntriesMustHaveWorkType,
    [validationRules.onlyAllowWithinEmployment]: OnlyAllowWithinEmployment,
    [validationRules.noCellErrors]: NoCellErrors,
    // [validationRules.hourLimitEnabled]: NoMoreThenXHours,
    [validationRules.maxHoursPerPeriodEnabled]: NoMoreThenXHours,
    // [validationRules.maxHoursPerDayEnabled]: NoMoreThenXHours,
    // [validationRules.maxHoursAllowedPerDay]: NoMoreThanXHoursPerDay,
    // [validationRules.EmptyTimeSheetNotAllowed]: EmptyTimeSheetNotAllowed,
    [validationRules.useFlowValidation]: FlowValidation,
    [validationRules.minPercentPerDayEnabled]: MinPercentPerDay,
    [validationRules.maxPercentOfCapacityEnabled]: MaxPercentOfCapacity,
};

//Configuration conmponents
export const configComponent = {
    [validationRules.maxHoursAllowedPerPeriod]: NoMoreThenXHoursConfig,
    [validationRules.useFlowValidation]: FlowValidationConfig,
    [validationRules.minPercentPerDayEnabled]: MinPercentPerDayConfig,
    [validationRules.maxPercentOfCapacityEnabled]: MaxPercentOfCapacityConfig,
};
